import { Box } from "@mui/material";

export default function AdminAppCardWrapper({ children }) {
  return (
    <Box
      sx={{
        display: "flex",
        padding: "16px 24px",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
        alignSelf: "stretch",
        borderRadius: "8px",
        background: "#F3F7FD",
      }}
    >
      {children}
    </Box>
  );
}
